import { BRANDS_WITH_REQUIRED_FREIGHT } from '@cannect/utils/constants'
import LoadingContainer from 'components/LoadingContainer'
import { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { toast } from 'react-toastify'
import { Home, IdCard } from '../../assets/svg/sendDocuments'
import { SendPrescription } from '../../new-components/SendDocument'
import { RedLabelInformation, StepsSendDocuments } from '../../new-components/atoms'

interface SendImportDocumentsUIProps {
  documentId: string | null
  handleContinue: any
  prescriptionFiles: any
  orderData: any
  orderLoading: any
  existingDocuments: any
  handleAddressDrop: any
  handleAddressFileSelect: any
  handleIdentityDrop: any
  handleIdentityFileSelect: any
  handleRelationshipDrop: any
  handleRelationshipFileSelect: any
  handleTakePhoto: any
  handleDragOver: any
  handleDragLeave: any
  setCurrentStep: any
  sendDocuments: any
  deleteDocument: any
  addressFiles: any
  identityFiles: any
  relationshipFiles: any
  canContinue: any
  addressUploadState: any
  identityUploadState: any
  relationshipUploadState: any
  hasUploaded: any
  setHasUploaded: any
  documentRefused: any
  setDocumentRefused: any
  responseType: 'normal' | 'ocr'
  automaticReadingEnabled: boolean
  setAutomaticReadingEnabled: (value: boolean) => void
  isLoading: boolean
  onKeepDocument: () => void
  /** Sobrescreve o redirect padrão quando o pedido não requer esta etapa */
  onInvalidOrderStatus?: () => void
  /** Associação exige laudo médico independente do tipo de produto */
  alwaysRequireLaudo?: boolean
}

export const SendImportDocumentsUI = ({
  handleContinue,
  orderData,
  orderLoading,
  handleTakePhoto,
  handleDragOver,
  handleDragLeave,
  setCurrentStep: setHookCurrentStep,
  sendDocuments,
  deleteDocument,
  handleAddressDrop,
  handleAddressFileSelect,
  handleIdentityDrop,
  handleIdentityFileSelect,
  handleRelationshipDrop,
  handleRelationshipFileSelect,
  existingDocuments,
  addressFiles,
  identityFiles,
  relationshipFiles,
  canContinue,
  addressUploadState,
  identityUploadState,
  relationshipUploadState,
  hasUploaded,
  setHasUploaded,
  documentRefused,
  setDocumentRefused,
  responseType,
  automaticReadingEnabled,
  setAutomaticReadingEnabled,
  isLoading,
  onKeepDocument,
  documentId,
  onInvalidOrderStatus,
  alwaysRequireLaudo = false
}: SendImportDocumentsUIProps) => {
  const history = useHistory()

  const [currentStep, setCurrentStep] = useState(2)

  useEffect(() => {
    setHookCurrentStep('otherDocuments')
  }, [setHookCurrentStep])

  useEffect(() => {
    if (orderData && orderData.status) {
      const allowedStatuses = ['pending', 'approved', 'processing']
      if (!allowedStatuses.includes(orderData.status)) {
        toast.info('Este pedido não requer envio de documentos')
        if (onInvalidOrderStatus) {
          onInvalidOrderStatus()
        } else {
          history.push('/painel-do-usuario')
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [orderData, history])

  if (orderLoading) {
    return <LoadingContainer loading={orderLoading} />
  }

  const handleAddressSuccess = () => {
    toast.success('Documento de endereço enviado com sucesso!')
  }

  const handleIdentitySuccess = () => {
    toast.success('Documento de identidade enviado com sucesso!')
  }

  const handleRelationshipSuccess = () => {
    toast.success('Documento de vínculo enviado com sucesso!')
  }

  if (!orderData) {
    return (
      <div style={{ minHeight: '100vh', backgroundColor: '#f5f5f5', padding: '20px 0' }}>
        <div style={{ height: '100vh', backgroundColor: '#f5f5f5', padding: '20px 0' }}>
          <div style={{ textAlign: 'center', padding: '40px', color: '#666', fontSize: '1.1rem' }}>
            Pedido não encontrado. Redirecionando...
          </div>
        </div>
      </div>
    )
  }

  const items = orderData?.order?.items.filter((item: any) => item.product?.type === 'PRODUTO') || []

 const allProductsPharmacy = items.every(
    (item: any) => item.supplier_id === 18
  )

  const hasLaudoProducts =
    alwaysRequireLaudo ||
    items.some((item: any) => item.product?.delivery_by_association === true || item.class_id === 4)

  const allProductsAreSupplements = items.every((item: any) => item.class_id === 6)

  const allProductsAreFreightBrand = items.every((item: any) => BRANDS_WITH_REQUIRED_FREIGHT.includes(item.brand_id))

  const allProductsDontNeedAnvisa = items.every(
    (item: any) =>
      item.product?.delivery_by_association === true ||
      item.class_id === 4 ||
      item.class_id === 6 ||
      BRANDS_WITH_REQUIRED_FREIGHT.includes(item.brand_id)
  )

  let customSteps

  if (alwaysRequireLaudo && !allProductsDontNeedAnvisa) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Laudo Médico' },
      { number: 4, text: 'Autorização Anvisa' },
      { number: 5, text: 'Dados da entrega' }
    ]
  } else if (alwaysRequireLaudo) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Laudo Médico' },
      { number: 4, text: 'Dados da entrega' }
    ]
  } else if (allProductsPharmacy) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Dados da entrega' }
    ]
  } else if (allProductsAreSupplements) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Dados da entrega' }
    ]
  } else if (allProductsAreFreightBrand) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Laudo Médico' },
      { number: 4, text: 'Dados da entrega' }
    ]
  } else if (allProductsDontNeedAnvisa && hasLaudoProducts) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Laudo Médico' },
      { number: 4, text: 'Dados da entrega' }
    ]
  } else if (hasLaudoProducts && !allProductsDontNeedAnvisa) {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Laudo Médico' },
      { number: 4, text: 'Autorização Anvisa' },
      { number: 5, text: 'Dados da entrega' }
    ]
  } else {
    customSteps = [
      { number: 1, text: 'Envio de receita' },
      { number: 2, text: 'Envio de documentos' },
      { number: 3, text: 'Autorização Anvisa' },
      { number: 4, text: 'Dados da entrega' }
    ]
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      <div style={{ padding: '20px 0' }}>
        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 20px' }}>
          <StepsSendDocuments
            currentStep={currentStep}
            automaticReadingEnabled={automaticReadingEnabled}
            onToggleAutomaticReading={setAutomaticReadingEnabled}
            customSteps={customSteps}
          />
        </div>
      </div>

      <div style={{ padding: '20px 0' }}>
        <div style={{ width: '100%', padding: '0 20px' }}>
          <RedLabelInformation>
            Os documentos solicitados abaixo são exigidos pela Anvisa. Mas não se preocupe! Caso não possa anexá-los
            agora, você poderá enviá-los posteriormente.
          </RedLabelInformation>
        </div>
      </div>

      <div style={{ padding: '20px 0' }}>
        <div style={{ width: '100%', padding: '0 20px' }}>
          <SendPrescription
            onDrop={handleAddressDrop}
            onFileSelect={handleAddressFileSelect}
            onTakePhoto={handleTakePhoto}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            multiple
            supportedFiles={['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']}
            maxSize="10MB"
            size="sm"
            title="Envie seu comprovante de endereço"
            icon={<Home />}
            description="Comprovante emitido nos últimos 5 meses, em nome do paciente que consta na receita e com CEP do endereço de entrega."
            stepName="address"
            requestFile={addressFiles[0]}
            responseType={responseType}
            onSuccess={handleAddressSuccess}
            documentId={documentId || ''}
            existingDocuments={
              existingDocuments ? existingDocuments.filter((doc: any) => doc.type === 'RESIDENCIAL') : []
            }
            onDeleteDocument={deleteDocument}
            uploadState={addressUploadState}
            sendDocuments={sendDocuments}
            deleteDocument={deleteDocument}
            documentRefused={documentRefused}
            setDocumentRefused={setDocumentRefused}
            hasUploaded={hasUploaded}
            setHasUploaded={setHasUploaded}
            onKeepDocument={onKeepDocument}
          />
        </div>
      </div>

      <div style={{ padding: '20px 0' }}>
        <div style={{ width: '100%', padding: '0 20px' }}>
          <SendPrescription
            onDrop={handleIdentityDrop}
            onFileSelect={handleIdentityFileSelect}
            onTakePhoto={handleTakePhoto}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            multiple
            supportedFiles={['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']}
            maxSize="10MB"
            size="sm"
            title="Envie seu documento de identidade"
            icon={<IdCard />}
            description="O documento precisa estar registrado em nome do paciente e deve ser claramente legível, tanto na frente quanto no verso."
            stepName="identity"
            requestFile={identityFiles[0]}
            responseType={responseType}
            onSuccess={handleIdentitySuccess}
            documentId={documentId || ''}
            existingDocuments={
              existingDocuments ? existingDocuments.filter((doc: any) => doc.type === 'IDENTIDADE') : []
            }
            onDeleteDocument={deleteDocument}
            uploadState={identityUploadState}
            sendDocuments={sendDocuments}
            hasUploaded={hasUploaded}
            setHasUploaded={setHasUploaded}
            documentRefused={documentRefused}
            setDocumentRefused={setDocumentRefused}
            onKeepDocument={onKeepDocument}
          />
        </div>
      </div>

      <div style={{ padding: '20px 0' }}>
        <div style={{ width: '100%', padding: '0 20px' }}>
          <SendPrescription
            onDrop={handleRelationshipDrop}
            onFileSelect={handleRelationshipFileSelect}
            onTakePhoto={handleTakePhoto}
            onDragOver={handleDragOver}
            onDragLeave={handleDragLeave}
            accept=".pdf,.doc,.docx,.jpg,.jpeg,.png"
            multiple
            supportedFiles={['.pdf', '.doc', '.docx', '.jpg', '.jpeg', '.png']}
            maxSize="10MB"
            size="sm"
            title="Comprovante de vinculo ou dependente"
            icon={<IdCard />}
            showAsterisk={false}
            description="Se o comprovante de endereço não estiver no nome do paciente, é necessário comprovar o vínculo com o titular. Para menores de idade, apresentar vínculo com o responsável legal."
            stepName="affiliation"
            requestFile={relationshipFiles[0]}
            responseType={responseType}
            onSuccess={handleRelationshipSuccess}
            documentId={documentId || ''}
            existingDocuments={existingDocuments ? existingDocuments.filter((doc: any) => doc.type === 'VINCULO') : []}
            onDeleteDocument={deleteDocument}
            uploadState={relationshipUploadState}
            sendDocuments={sendDocuments}
            documentRefused={documentRefused}
            setDocumentRefused={setDocumentRefused}
            hasUploaded={hasUploaded}
            setHasUploaded={setHasUploaded}
            onKeepDocument={onKeepDocument}
          />
        </div>
      </div>

      {canContinue() && (
        <div style={{ padding: '40px 0', textAlign: 'end' }}>
          <div style={{ width: '100%', padding: '0 20px' }}>
            <button
              onClick={handleContinue}
              disabled={isLoading || !canContinue()}
              style={{
                background: isLoading || !canContinue() ? '#ccc' : '#748351',
                color: 'white',
                border: 'none',
                borderRadius: '8px',
                padding: '16px 48px',
                fontSize: '1.1rem',
                fontWeight: 600,
                cursor: isLoading || !canContinue() ? 'not-allowed' : 'pointer',
                transition: 'background-color 0.2s',
                minWidth: '200px'
              }}>
              {isLoading ? 'Enviando...' : canContinue() ? 'Continuar' : 'Aguarde todos os documentos'}
            </button>
          </div>
        </div>
      )}
    </div>
  )
}
